import { Star } from "lucide-react";

const StarRating = ({ rating }) => (
  <div className="flex gap-1">
    {[...Array(rating)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber-500 text-amber-500" />
    ))}
  </div>
);

export default StarRating;
